export default __webpack_public_path__ + "static/media/laFlor.2b90495d.png";